import { SET_ID_USER_ACTION } from "./reducersConstants";

export const setIdUserAction = (data) => {
  return {
    type: SET_ID_USER_ACTION,
    data,
  };
};

export const idUserReducer = (previousState = "", { type, data }) => {
  switch (type) {
    case SET_ID_USER_ACTION:
      return data;
    default:
      return previousState;
  }
};
